import { NotificationDatasource } from "@core/data/datasources/notification.datasource";
import { DismissAllNotificationsDto } from "@core/data/dto/notification.dto";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { Notification } from "@core/domain/models/notification.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class NotificationRepository {
    constructor(
        @inject(NotificationDatasource)
        private readonly datasource: NotificationDatasource,
    ) {}

    fetchMy(limit?: number): Promise<Either<FallbackError, Notification[]>> {
        return this.datasource.fetchMy(limit);
    }

    fetchUnreadCount(): Promise<Either<FallbackError, number>> {
        return this.datasource.fetchUnreadCount();
    }

    markRead(id: number): Promise<Either<FallbackError, true>> {
        return this.datasource.markRead(id);
    }

    dismiss(id: number): Promise<Either<FallbackError, true>> {
        return this.datasource.dismiss(id);
    }

    dismissAll(): Promise<Either<FallbackError, DismissAllNotificationsDto>> {
        return this.datasource.dismissAll();
    }
}
